import { Component, Input } from '@angular/core';
import { SiteWidget } from '../widget.interface';
import { TranslateService } from '@ngx-translate/core';
import { BattlinkSitePerformanceService } from '../battlink-site-performance.service';
import * as _ from 'underscore';
import { TableData } from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';

@Component({
	selector: 'app-eq-weekly-summary',
	templateUrl: './eq-weekly-summary.component.html',
})
export class EqWeeklySummaryComponent {
	@Input() siteId: number;
	@Input() customerId: number;
	@Input() devices: any = {};
	@Input() deviceTags: any;
	@Input() tags: any;
	@Input() data: any;

	widgetConfig: SiteWidget = {
		data: [],
		tableData: {},
		scale: 100,
		config: {
			hAxis: { title: this.translateService.instant('site_performance.eq_cycles_percent') },
			vAxis: { title: this.translateService.instant('site_performance.batteries_percent'), format: "0" },
			legend: "none",
			colors: ['#e92f31', '#e92f31', '#e92f31', '#fb5025', '#fb902c', '#faa82f', '#fad938', '#fcff99', '#d0ff9e', '#b6fd94', '#16fe45'],
			isStacked: true
		},
		columnNames: [ "Type", "", { role: "style", type: "string" }],
		type: "ColumnChart",
		title: this.translateService.instant('site_performance.eq_weekly_summary'),
		tooltip: "",
		widgetId: "battery_eq_summary",
		dataRanges: [ "last_7_days", "last_30_days", "last_90_days", "yesterday", "last_week" ],
		selectedDateRange: "yesterday",
		filterByTag: true,
		selectedTags: [],
		filterByType: true,
		selectedType: "all",
		hideWidget: true,
		stackColumn: "truck_type",
		groups: [
			["0%", 5],
			["10%", 15],
			["20%", 25],
			["30%", 35],
			["40%", 45],
			["50%", 55],
			["60%", 65],
			["70%", 75],
			["80%", 85],
			["90%", 95],
			["100%", 100],
		],
		formateWidgetData: this.formateData,
		tableConfig:{
			columns: [
				{ key: 'batteryId', name: this.translateService.instant('device_performance.battery_id'), type: 'link' },
				{ key: 'batterySn', name: this.translateService.instant('device_performance.battery_sn'), type: 'string' },
				{ key: 'eqWeeklySummaryValue', name: this.translateService.instant('g.value'), type: 'number' }
			],
			dataKeys: ['batteryId', 'batterySn', 'eqWeeklySummaryValue'],
			sortBy: 'appearName',
			exportFileName: this.translateService.instant('site_performance.battery_fleet_utilization'),
			sizeColumnsToFit: true
		},
		dropDownGroupList: [
			{
				name: 'date_range',
				label: '',
				options: [
					{label: 'Yesterday', value: 'yesterday'},
					{label: 'Last Week', value: 'last_week'},
					{label: 'Last 7 days', value: 'last_7_days'},
					{label: 'Last 30 days', value: 'last_30_days'},
					{label: 'Last 90 days', value: 'last_90_days'},
				],
			},
			{
				name: 'truck_type',
				label: 'Truck Type',
				options: [
					{label: 'All Types', value: 'all'},
				]
			},
			{
				name: 'tag',
				label: 'Tags',
				options: [
					{label: 'All Tags', value: 'all'},
				]
			},
		],
		selectedDropDown: {date_range: 'yesterday', truck_type: 'all', tag: 'all'},
	};

	tableItems: any[] = [];
	chartTableConfig: any = {data: [], column: []};
	tableColumns: any[] = [];
	exportFileName: string = "";
	sizeColumnsToFit: boolean = true;
	noDataForCurrentFilters: boolean = false;

	constructor(
		private translateService: TranslateService,
		private battlinkSitePerformanceService: BattlinkSitePerformanceService,
	) {
		this.formateData = this.formateData.bind(this);
	}

	ngOnInit() {
		this.updateWidgetData();
		this.battlinkSitePerformanceService.updateTagsList(this.widgetConfig, this.tags);
		this.battlinkSitePerformanceService.updateTypesListForWidget(this.widgetConfig);
	}

	formateData(widget: SiteWidget, data: any, devices: any, defaultCountOfDays: number, availableDaysByDevices: any): any {
		const returnData = {};
		for(let macAddress in data) {
			if(!devices[macAddress])
				continue;

			let countOfDays = defaultCountOfDays;
			returnData[macAddress] = {};
			let avg = 0;

			if(availableDaysByDevices[macAddress])
				countOfDays = availableDaysByDevices[macAddress];

			if(countOfDays > 0)
				avg = data[macAddress] / countOfDays;

			returnData[macAddress].avg = avg;
			returnData[macAddress].countOfDays = countOfDays;
			returnData[macAddress].total = data[macAddress];
		}

		return returnData;
	}

	onSelect(event) {
		if(!event)
			return;

		let selectedIndex = event.row;
		let selectedDevicesInfo = this.widgetConfig.tableData[selectedIndex];
		this.fillGridTableData(selectedDevicesInfo);
		this.prepareWidgetModalTable();
	}

	prepareWidgetModalTable() {
		const config = this.widgetConfig.tableConfig;
		this.tableColumns = config.columns;
		this.exportFileName = config.exportFileName;
		this.sizeColumnsToFit = config.sizeColumnsToFit;

		if (config) {
			this.chartTableConfig.column = config.columns;
			this.chartTableConfig.data = this.tableItems.map((row) => {
				const rowData: TableData = {
					batterySn: { value: row.batterySn?.value },
					batteryId: { value: row.batteryId?.value },
					eqWeeklySummaryValue: { value: row.eqWeeklySummaryValue?.value || 0 },
				};

				return rowData;
			});
		}
	}

	fillGridTableData(selectedDevicesInfo, ) {
		let tableItems = [];

		for(let item of selectedDevicesInfo) {
			if(!this.devices[item.mac])
				continue;

			let temp = {
				batterySn: {value: item.serial_number},
				batteryId: {value: item.truck_id},
				eqWeeklySummaryValue: {value: item.avg || "0"},
			};
			tableItems.push(temp);
		}

		if (this.widgetConfig.tableConfig.sortBy) {
			const sortKey = this.widgetConfig.tableConfig.sortBy;
			tableItems = _.sortBy(tableItems, item => item[sortKey]?.value).reverse();
		}

		this.tableItems = tableItems;
	}

	onFilter(filter) {
		this.battlinkSitePerformanceService.updateFilter(this.widgetConfig, filter);

		this.updateWidgetData();
	}

	updateWidgetData() {
		this.battlinkSitePerformanceService.generateWidgetData(this.widgetConfig, this.data, this.devices, this.deviceTags);
		this.noDataForCurrentFilters = this.widgetConfig.data.length === 0;
	}
}
